import * as React from 'react';
import { isModifiedClickEvent } from '@grandvisionhq/utils';
import { updateActiveVariant } from '../../../context/actions.js';
import '../../../context/reducer.js';
import { useProductData } from '../../../context/product-context-hooks.js';
import '../../../context/ProductContext.js';
import '../../../context/CmsContext.js';
import { getFacetPickerConfig } from '../utils/get-facet-picker-config.js';

const EcommFacetContext = /*#__PURE__*/ React.createContext({});
const useEcommFacetContext = ()=>React.useContext(EcommFacetContext)
;
const EcommFacetProvider = ({ children  })=>{
    const { dispatch , product: { facetTree  } , activeVariant: { sku: sku1  } ,  } = useProductData();
    const handleVariantSelection = React.useCallback(({ event , sku , href  })=>{
        // Allow customers to open another variant in a new tab or window, otherwise prevent navigation
        if (!event || !isModifiedClickEvent(event)) {
            event === null || event === void 0 ? void 0 : event.preventDefault();
            dispatch(updateActiveVariant({
                sku
            }));
            window.history.replaceState(null, '', href);
        }
    }, [
        dispatch
    ]);
    const [userHasSelectedASize, setUserHasSelectedASize] = React.useState(false);
    const [notificationType, setNotificationType] = React.useState(undefined);
    const facetPickerConfig = getFacetPickerConfig(facetTree, sku1);
    const isValid = React.useMemo(()=>!facetPickerConfig.requiresUserSizeSelection || facetPickerConfig.requiresUserSizeSelection && userHasSelectedASize
    , [
        facetPickerConfig.requiresUserSizeSelection,
        userHasSelectedASize
    ]);
    const value = {
        facetPickerConfig,
        isValid,
        handleVariantSelection,
        userHasSelectedASize,
        setUserHasSelectedASize,
        notificationType,
        setNotificationType
    };
    return /*#__PURE__*/ React.createElement(EcommFacetContext.Provider, {
        value: value
    }, children);
};

export { EcommFacetContext, EcommFacetProvider, useEcommFacetContext };
//# sourceMappingURL=EcommFacetContext.js.map
